import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { CertificateListItem } from "../types";

const CertificateRow: React.FC<{ item: CertificateListItem }> = ({ item }) => {
  const theme = useTheme();
  const meta = [`ID: ${item.id}`, item.description].filter(Boolean).join(" | ");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 700,
          color: theme.palette.text.primary,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {item.name}
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          color: theme.palette.text.tertiary,
          lineHeight: 1.4,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {meta}
      </Typography>
    </Box>
  );
};

export default CertificateRow;
